import { ref, reactive, defineComponent } from 'vue';
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue.js";
import { Navigation, Pagination, EffectFade } from "swiper";
import "swiper/swiper.min.css";
import "swiper/modules/effect-fade/effect-fade.min.css"; //引入轮播样式-

import 'swiper/modules/pagination/pagination.min.css';
export default defineComponent({
  components: {
    Swiper: Swiper,
    SwiperSlide: SwiperSlide
  },
  name: 'BannerSwiper',
  props: {
    bannerList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup() {
    var swiper_option = reactive({
      autoplay: {
        delay: 6000,
        disableOnInteraction: false
      },
      fadeEffect: {
        crossFade: false
      },
      loop: true,
      speed: 1000
    });
    return {
      swiper_option: swiper_option,
      modules: [EffectFade, Pagination, Navigation]
    };
  }
});